import * as Cookie from 'js-cookie';
import { MeasuredCookieType } from './types';
import { cookieKey } from './constants';
export class MeasuredCookie {
    static hasCookie() {
        return Cookie.get(cookieKey) !== '' ? true : false;
    }
    static get(type) {
        var _Cookie_get;
        const current = this.decode((_Cookie_get = Cookie.get(cookieKey)) !== null && _Cookie_get !== void 0 ? _Cookie_get : '');
        return current[type];
    }
    static write(type, size) {
        if (!window) {
            return;
        }
        var _Cookie_get;
        const current = this.decode((_Cookie_get = Cookie.get(cookieKey)) !== null && _Cookie_get !== void 0 ? _Cookie_get : '');
        current[type] = size;
        Cookie.set(cookieKey, this.encode(current), {
            domain: `.deviantart.${process.env.NODE_ENV === 'development' ? 'lan' : 'com'}`,
            sameSite: 'lax'
        });
    }
    // decodes 0:110;1:344 to { 0: 110, 1: 344 }
    static decode(store) {
        const stored = {};
        if (!store) {
            return stored;
        }
        const keyvals = store.split(';');
        if (keyvals.length === 0) {
            return stored;
        }
        const typeToDim = keyvals.map((v)=>v.split(':'));
        if (typeToDim.length === 0) {
            return stored;
        }
        for (const typeDim of typeToDim){
            if (typeDim.length !== 2 || !MeasuredCookieType[typeDim[0]]) {
                continue;
            }
            const sizes = typeDim[1].split('x');
            if (sizes.length > 2) {
                continue;
            }
            stored[typeDim[0]] = sizes.length === 1 ? parseInt(sizes[0]) : [
                parseInt(sizes[0]),
                parseInt(sizes[1])
            ];
        }
        return stored;
    }
    static encode(stored) {
        const store = [];
        for(const key in stored){
            if (!MeasuredCookieType[key]) {
                continue;
            }
            const value = Array.isArray(stored[key]) ? stored[key].join('x') : stored[key];
            store.push(`${key}:${value}`);
        }
        return store.join(';');
    }
}

//# sourceMappingURL=MeasuredCookie.js.map